/**
 * Favoritos / Wishlist
 * Client-side only (localStorage) — no account required. Persists across
 * pages/visits on the same browser. Powers <favorite-button> (product cards
 * and the product page) plus the header counter and the /pages/favoritos page.
 */
(function () {
  var STORAGE_KEY = 'mexia:wishlist';

  function readWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      /* Storage full or unavailable (private browsing) — fail silently. */
    }
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
  }

  function isSaved(id) {
    return readWishlist().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function toggle(item) {
    var items = readWishlist();
    var index = items.findIndex(function (i) {
      return String(i.id) === String(item.id);
    });
    var nowSaved;
    if (index > -1) {
      items.splice(index, 1);
      nowSaved = false;
    } else {
      items.unshift(item);
      nowSaved = true;
    }
    writeWishlist(items);
    return nowSaved;
  }

  function remove(id) {
    var items = readWishlist().filter(function (item) {
      return String(item.id) !== String(id);
    });
    writeWishlist(items);
  }

  class FavoriteButtonElement extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('.favorite-button__toggle');
      if (!this.toggleButton) return;
      this.productId = this.dataset.productId;
      this.boundUpdate = this.updateState.bind(this);
      this.updateState();
      this.toggleButton.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('wishlist:change', this.boundUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:change', this.boundUpdate);
    }

    onClick(event) {
      event.preventDefault();
      var item = {
        id: this.dataset.productId,
        handle: this.dataset.productHandle,
        title: this.dataset.productTitle,
        image: this.dataset.productImage,
        price: this.dataset.productPrice,
        url: this.dataset.productUrl
      };
      toggle(item);
      this.toggleButton.classList.add('is-animating');
      var self = this;
      window.setTimeout(function () {
        self.toggleButton.classList.remove('is-animating');
      }, 420);
    }

    updateState() {
      var saved = isSaved(this.productId);
      this.toggleButton.classList.toggle('is-active', saved);
      this.toggleButton.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = saved ? this.dataset.labelRemove : this.dataset.labelAdd;
      var labelEl = this.querySelector('.favorite-button__label');
      if (label && labelEl) labelEl.textContent = label;
    }
  }

  if (!customElements.get('favorite-button')) {
    customElements.define('favorite-button', FavoriteButtonElement);
  }

  function updateWishlistCount() {
    var count = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  document.addEventListener('wishlist:change', updateWishlistCount);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistCount);
  } else {
    updateWishlistCount();
  }

  window.MexiaWishlist = {
    read: readWishlist,
    toggle: toggle,
    remove: remove,
    isSaved: isSaved
  };
})();
